import React from "react";
export default class LabelEditable extends React.Component {
  constructor(props) {
    super(props);
    this.state = { elemRef: React.createRef() };
  }
  onKeyDown = (e) => {
    if (e.key === "Enter" && this.props.editable) {
      e.preventDefault();
      if (this.state.elemRef.current) {
        this.state.elemRef.current.blur();
      }
      return false;
    }
  };
  onBlur = (e) => {
    if (this.state.elemRef.current && this.props.editable) {
      let newValue = this.props.input
        ? this.state.elemRef.current.value.trim()
        : this.state.elemRef.current.innerHTML.trim();
      if (newValue && newValue !== this.props.value)
        this.props.onChange(newValue);
    }
  };
  onClick = () => {
    if (
      this.state.elemRef.current &&
      this.props.editable &&
      !this.props.input
    ) {
      document.execCommand("selectAll", false, null);
    }
  };
  render() {
    const styles = {
      WebkitUserModify: this.props.editable
        ? "read-write-plaintext-only"
        : "read-only",
      outlineColor: "#3699ff",
      backgroundColor: "#ffffff",
      borderRadius: "5px",
      padding: "5px",
    };
    if (this.props.input) {
      return (
        <>
          <input
            type="text"
            ref={this.state.elemRef}
            onKeyDown={this.onKeyDown}
            onBlur={this.onBlur}
            onClick={this.onClick}
            defaultValue={this.props.value}
            className="form-control"
          />
        </>
      );
    } else {
      return (
        <>
          <span
            ref={this.state.elemRef}
            onKeyDown={this.onKeyDown}
            onBlur={this.onBlur}
            onClick={this.onClick}
            style={styles}
          >
            {this.props.value}
          </span>
        </>
      );
    }
  }
}
